import { rem } from 'polished'
import styled from '@emotion/styled'
import { COLORS } from 'utils'
import theme from '@nextretreat/ui-components/dist/Theme'

export interface IProgressBarProps {
  end: number
  current: number
}

interface IFillerProps {
  completed: number
}

const Container = styled('div')`
  height: ${rem(30)};
  width: 100%;
  border-radius: ${rem(15)};
  background-color: ${COLORS.IRRADIANT_IRIS};
  overflow: hidden;
`

const Label = styled('div')`
  padding: ${rem(5)};
  color: ${theme.COLORS.WHITE};
`

const Filler = styled(`div`)<IFillerProps>`
  height: 100%;
  width: ${({ completed }) => completed}%;
  transition: width 1s ease-in-out;
  background-color: ${COLORS.EXPLORATION_GREEN};
  border-radius: ${rem(15)};
  text-align: 'right';
`

export const ProgressBar = ({ end, current }: IProgressBarProps) => {
  const completed = (current / end) * 100

  return (
    <Container>
      <Filler completed={completed}>
        <Label>{`${current}/${end}`}</Label>
      </Filler>
    </Container>
  )
}
